export const dateFormat = (date, format) => {
  if (!date) return date
  if (date instanceof String) {
    date = date.replace(' ', 'T')
  }
  date = new Date(date)
  date.setHours(date.getHours() - (date.getTimezoneOffset() - (new Date()).getTimezoneOffset()) / 60)
  if (!format) {
    return date
  }
  let map = {
    'yyyy': date.getFullYear(),
    'MM': date.getMonth() + 1,
    'dd': date.getDate(),
    'hh': date.getHours(),
    'mm': date.getMinutes(),
    'ss': date.getSeconds(),
    'S': date.getMilliseconds()
  }
  for (let key in map) {
    format = format.replace(new RegExp(key, 'g'), (map[key] + '').padStart(2, '0'))
  }
  return format
}

export const convertFileSize = (_byte, split = '', step, lower = false) => {
  const sizeType = lower ? ['', 'k', 'm', 'g', 't', 'p', 'e', 'z', 'y', 'b', 'ge'] : ['', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y', 'B', 'Ge']
  let type = 0
  for (; _byte > 1024 || type === sizeType.length; _byte /= 1024, type++) {}
  return fixNumber(_byte, step) + split + sizeType[type] + 'B'
}

export const convertNumberCount = (_count, split = '', step, lower = false) => {
  const sizeType = lower ? ['', 'k', 'm', 'b', 't', 'q'] : ['', 'K', 'M', 'B', 'T', 'Q']
  let type = 0
  for (; _count > 1000 || type === sizeType.length; _count /= 1000, type++) {}
  return fixNumber(_count, step) + split + sizeType[type]
}

export const groupBy = (ary, f, needKey = false) => {
  let groups = {}
  for (let i = 0; i < ary.length; i++) {
    let key = needKey ? f(ary[i], i) : JSON.stringify(f(ary[i], i))
    if (key) {
      groups[key] = groups[key] || []
      groups[key].push(ary[i])
    }
  }
  return needKey ? groups : Object.values(groups)
}

export const sortData = (arr, keys, orders) => {
  if (!arr || !(arr instanceof Array)) {
    return arr
  }
  if (keys instanceof Object && !(keys instanceof Array) && !(keys instanceof Function)) {
    return arr
  }
  keys = keys instanceof Array ? keys : [keys]
  orders = orders instanceof Array ? orders : [orders]
  if (keys.length <= 0) {
    return arr
  }
  const sortBy = (keys, orders) => (o1, o2) => {
    let key = keys[0]
    let order = orders[0] !== 'desc' ? 1 : -1
    let co1 = key instanceof Function ? key(o1, order) : o1[key]
    let co2 = key instanceof Function ? key(o2, order) : o2[key]
    co1 = co1 instanceof Array ? co1.length : co1
    co2 = co2 instanceof Array ? co2.length : co2
    if (co1 === null || co1 === undefined || co1 < co2) {
      return -1 * order
    } else if (co2 === null || co2 === undefined || co1 > co2) {
      return 1 * order
    } else {
      return keys.length <= 1 ? 0 : sortBy(keys.slice(1), orders.length > 0 ? orders.slice(1) : orders)(o1, o2)
    }
  }
  return [...arr].sort(sortBy(keys, orders))
}

export const toFormdata = (object, needEmpty = false, arrayFix = '[]') => {
  let formData = new FormData()
  for (let kv of Object.entries(object)) {
    if (needEmpty || (kv[1] !== null && kv[1] !== undefined)) {
      if (kv[1] instanceof Array) {
        for (let data of kv[1]) {
          formData.append(kv[0] + arrayFix, data)
        }
      } else {
        formData.append(kv[0], kv[1])
      }
    }
  }
  return formData
}

export const fixNumber = (value, step, fix = 1) => {
  step = step || value
  const len = ((step + '').match(/\.(.*?)$/) || ['', ''])[1].length + -Math.log10(fix)
  value = Math.round(value * Math.pow(10, len)) / Math.pow(10, len)
  return value
}

export const copyToClipboard = (value) => {
  navigator.clipboard.writeText(value)
}

export const htmlencode = (s) => {
  let div = document.createElement('div')
  div.appendChild(document.createTextNode(s))
  return div.innerHTML
}

export const htmldecode = (s) => {
  let div = document.createElement('div')
  div.innerHTML = s
  return div.innerText || div.textContent
}

export const fileTypeCheck = (e, operation, onError) => {
  let acceptTypes = e.target.getAttribute('accept')
  acceptTypes = acceptTypes ? acceptTypes.split(',') : null
  let extension = e.target.getAttribute('extension')
  extension = extension ? extension.split(',') : null
  let match = (arys, s) => {
    for (let ary of arys) {
      let rgx = new RegExp(ary)
      if (rgx.test(s)) {
        return true
      }
    }
    return false
  }
  for (let file of e.target.files) {
    let fileType = file.type
    let fileExtension = file.name.split('.')
    fileExtension = fileExtension[fileExtension.length - 1]
    if (extension && !match(extension, fileExtension)) {
      e.target.value = ''
      if (onError) {
        onError(file, extension)
      }
      return
    }
    if (acceptTypes && !match(acceptTypes, fileType)) {
      e.target.value = ''
      if (onError) {
        onError(file, acceptTypes)
      }
      return
    }
  }
  operation(e)
}

export const downloadFile = (fileName, urlData, target) => {
  let aLink = document.createElement('a')
  if (fileName) {
    aLink.download = fileName
  }
  if (target) {
    aLink.target = target
  }
  aLink.href = urlData
  aLink.click()
}



// WEBPACK FOOTER //
// ./src/constants/global/util.js